export default __webpack_public_path__ + "static/media/Thanuja_Ranasinghe_AHV_In_Moms_We_Trust.691b00a2.jpg";